// The hero captivity global, read once per snapshot for the mission tab.
import type { GameSnapshot } from '@aod/protocol';
import { useMemo } from 'react';
import { type HeroCaptivity, readHeroCaptivity } from './captivity.js';

export function useHeroCaptivityView(snapshot: GameSnapshot | null): HeroCaptivity | null {
  return useMemo(() => readHeroCaptivity(snapshot), [snapshot]);
}
